import { produce } from 'immer';
import { Store, StoreConfig } from '@datorama/akita';
import { IFaceliftState } from './IFaceliftState';
import { Injectable } from '@angular/core';

function createInitialState(): IFaceliftState {
	return {
		isFaceliftEnabled: false
	};
}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'FaceliftStore', producerFn: produce })
export class FaceliftStore extends Store<IFaceliftState> {
	constructor() {
		super(createInitialState());
	}
}
